// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".splash-screen {\n    display: flex;\n    justify-content: center;\n}\n\n.splash-screen .image-wrapper {\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n    justify-content: center;\n    width: 425px;\n}\n", ""]);
// Exports
module.exports = exports;
